<template>
  <div>
    <v-card :loading="loading">
      <v-card-title class="d-flex justify-space-between"
        ><span>PDF list</span>
        <div>
          <v-btn color="primary" @click.stop="showAddDialog = true">
            <v-icon left>
              mdi-plus
            </v-icon>
            Add PDF
          </v-btn>
        </div></v-card-title
      >
      <v-card-text>
        <div v-if="(pdfs ? pdfs : []).length <= 0 && !loading">
          <v-banner single-line class="text-h6">No records</v-banner>
        </div>
        <v-row>
          <v-col cols="12" sm="6" md="6" v-for="i in pdfs" :key="i.id">
            <pdf-card :pdf="i" @refresh="fetchPdfs" />
          </v-col>
        </v-row>
        <v-pagination
          v-if="this.pagination != undefined && this.pagination.totalItems > 0"
          v-model="pagination.currentPage"
          circle
          v-bind:length="pagination.pageCount"
          v-on:input="onRequestPageChange"
        ></v-pagination>
      </v-card-text>
    </v-card>
    <add-pdf-dialog
      :visible="showAddDialog"
      @close="showAddDialog = false"
      @refresh="fetchPdfs"
    />
  </div>
</template>

<script>
import PdfCard from '../../components/PdfCard.vue'
import pdfApi from '@/api/pdfApi'
import AddPdfDialog from '../../components/AddPdfDialog.vue'
export default {
  components: { PdfCard, AddPdfDialog },
  data () {
    return {
      pdfs: null,
      loading: false,
      query: {
        item_per_page: 10,
        publish_date: null,
        page: 1,
        sort: 'publish_date:desc'
      },
      showAddDialog: false,
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      }
    }
  },
  mounted () {
    this.fetchPdfs()
  },
  methods: {
    async fetchPdfs () {
      this.loading = true
      try {
        this.pdfs = []
        const r = await pdfApi.getPdfs(this.query)
        if (r.data.data !== undefined) {
          this.pdfs = r.data.data
          this.parsePaginationData(r.data)
        }
      } finally {
        this.loading = false
      }
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchNews()
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    },
    dateClearCallback () {
      this.query.publish_date = null
      this.fetchPdfs()
    }
  }
}
</script>
